'use client';

import { Skeleton } from '@mui/material';
import { HousingCardSkeleton } from '@/components';
import { Container, Head, Wrapper } from '@/features/pages/home';
import { GridList } from './styles';

export const IndividualProjectSkeleton = () => (
  <Wrapper>
    <Container>
      <Head>
        <Skeleton variant="text" width={280} height={40} />
      </Head>
      <GridList>
        {Array.from({ length: 6 }).map((_, i) => (
          <HousingCardSkeleton key={i} />
        ))}
      </GridList>
    </Container>
  </Wrapper>
);
